<template>
  <el-dialog top="40px" title="详情" class="view-file" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="1000px">

    <div class="view-file-win">
      <el-descriptions v-if="from_data.reason" class="margin-top" :column="2" size="mini" border>
        <el-descriptions-item label="房产">{{ from_data.reason.HouseName }}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{ from_data.reason.name }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ from_data.reason.phone }}</el-descriptions-item>
        <el-descriptions-item label="欠费类型">{{ from_data.reason.arrears_type }}</el-descriptions-item>
        <el-descriptions-item label="欠费原因">{{ from_data.reason.arrears_reason }}</el-descriptions-item>
        <el-descriptions-item :label="from_data.reason.type==5&&from_data.reason.type_ex==2?'诉调案号':(from_data.reason.type==5&&from_data.reason.type_ex==3?'受理案件号':'业主诉求')">{{ from_data.reason.user_appeal }}</el-descriptions-item>
        <el-descriptions-item label="催缴措施">{{ from_data.reason.measures }}</el-descriptions-item>
        <el-descriptions-item label="预计回款时间">{{ from_data.reason.ymd }}</el-descriptions-item>
        <el-descriptions-item label="催缴责任人">{{ from_data.reason.user_person_liable }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ from_data.reason.remarks }}</el-descriptions-item>
        <el-descriptions-item label="添加时间">{{ from_data.reason.created_at }}</el-descriptions-item>
      </el-descriptions>
      <div class="main-log">
        <el-steps size="mini" v-if="from_data.data" :space="150" direction="vertical" :active="from_data.data.length">
          <el-step v-for="(item,index) in from_data.data" :key="index">
            <template slot="title">
              <div>{{item.send_time}}</div>
              <p style="color:#414141;font-size: 14px;">
                类型：<span style="color: #656565">{{item.type_text}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;">
                操作人：<span style="color: #757575">{{item.work_name||'系统同步'}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                催缴金额：<span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{item.money}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                缴费金额：<span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{item.money}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                缴费方式：<span style="color: #757575">{{item.measures}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                缴费日期：<span style="color: #757575">{{item.created_at}}</span>
              </p>
              <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                添加时间：<span style="color: #757575">{{item.created_at}}</span>
              </p>
            </template>
            <template slot="description">
              <div v-if="(item.extend||'').indexOf('http')===-1" style="color: #6f7175">
                {{item.extend}}
              </div>
              <div v-else>
                <div v-for="(img,img_index) in item.extendImg" :key="img_index">
                  <el-popover
                    v-if="img"
                    placement="top-start"
                    title="预览"
                    width="500"
                    trigger="hover">
                    <el-image
                      style="width: 470px;"
                      :src="img"
                      fit="cover"></el-image>
                    <el-image
                      slot="reference"
                      style="width: 200px; height: 200px"
                      :src="img"
                      fit="cover"></el-image>
                  </el-popover>
                  <el-link type="primary" @click="openFile(img,1)">预览<i class="el-icon-view el-icon--right"></i> </el-link>&nbsp;&nbsp;&nbsp;&nbsp;
                  <el-link type="primary" @click="openFile(img,2)">下载<i class="el-icon-download el-icon--right"></i> </el-link>
                </div>

              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
    <template slot="footer">
      <div>
        <el-button icon="el-icon-close" @click="dialogVisible=false">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import LogController from "../../../../common/logger/LogController";
import ViewFileHelp from "../../../../common/ViewFileHelp";
import ButlerHttp from "../common/ButlerHttp";

export default {
  name: "LegalHouseInfo",
  data(){
    return{
      dialogVisible:false,
      from_data:{},
    }
  },
  methods:{
    show(item){
      const that=this;
      ButlerHttp.get("Legal/getDetails", {
        precinctid: item.project_house_id,
        houseid: item.house_id
      }, res => {
        if (res.code) {
          that.dialogVisible = true;
          res.data.reason.type = item.type;
          res.data.reason.type_ex = item.type_ex;
          res.data.data.map(ret_item => {
            if ((ret_item.extend || "").indexOf('http') === -1) {
              ret_item.extendImg = [];
            } else {
              ret_item.extendImg = ret_item.extend.split(",");
            }
          });
          console.log(res.data.data);
          that.from_data = res.data;
          LogController.start({
            group_name: "抽检记录",
            group_key: item.project_house_id,
            group_val: item.house_id,
            remarks: ""
          }, that.$route.path + "_1");
        } else {
          that.$message.error(res.msg || "无法访问");
        }
      });
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={};
      LogController.end(this.$route.path+"_1")
    },
    openFile(file,type=1){
      if(type===1){
        window.open(ViewFileHelp.getViewFileUrl(file))
      }else {
        // console.log(file)
        //把http转成https
        file = file.replace("http://","https://");
        //下载文件
        let aLink = document.createElement('a');
        aLink.href = file;
        aLink.download = file.substring(file.lastIndexOf("/") + 1);
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.view-file{
  .view-file-win{
    .main-log{
      height: 50vh;
      overflow-y: scroll;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LegalHouseInfo.vue